export const DEFAULT_GROUP = 0;
export const FIRST_PERIOD_GROUP = 1;
export const SECOND_PERIOD_GROUP = 2;
export const THIRD_PERIOD_GROUP = 3;
export const FOURTH_PERIOD_GROUP = 4;
export const FIFTH_PERIOD_GROUP = 5;
export const SIXTH_PERIOD_GROUP = 6;
export const SEVENTH_PERIOD_GROUP = 7;
export const EIGHTH_PERIOD_GROUP = 8;
export const NINTH_PERIOD_GROUP = 9;
export const TENTH_PERIOD_GROUP = 10;
export const ELEVENTH_PERIOD_GROUP = 11;
export const TWELFTH_PERIOD_GROUP = 12;
export const THIRTEENTH_PERIOD_GROUP = 13;
export const FOURTEENTH_PERIOD_GROUP = 14;
export const FIFTEENTH_PERIOD_GROUP = 15;
export const SIXTEENTH_PERIOD_GROUP = 16;
export const SEVENTEENTH_PERIOD_GROUP = 17;
export const EIGHTEENTH_PERIOD_GROUP = 18;
export const NINETEENTH_PERIOD_GROUP = 19;
export const TWENTIETH_PERIOD_GROUP = 20;
export const TWENTY_FIRST_PERIOD_GROUP = 21;
export const TWENTY_SECOND_PERIOD_GROUP = 22;
export const TWENTY_THIRD_PERIOD_GROUP = 23;
export const TWENTY_FOURTH_PERIOD_GROUP = 24;
export const TWENTY_FIFTH_PERIOD_GROUP = 25;
export const TWENTY_SIXTH_PERIOD_GROUP = 26;
export const TWENTY_SEVENTH_PERIOD_GROUP = 27;
export const TWENTY_EIGHTH_PERIOD_GROUP = 28;
export const TWENTY_NINTH_PERIOD_GROUP = 29;
export const THIRTIETH_PERIOD_GROUP = 30;
export const THIRTY_FIRST_PERIOD_GROUP = 31;
export const THIRTY_SECOND_PERIOD_GROUP = 32;
export const THIRTY_THIRD_PERIOD_GROUP = 33;
export const THIRTY_FOURTH_PERIOD_GROUP = 34;
export const THIRTY_FIFTH_PERIOD_GROUP = 35;
export const THIRTY_SIXTH_PERIOD_GROUP = 36;
export const THIRTY_SEVENTH_PERIOD_GROUP = 37;
export const FIRST_MINI_MATCH_GROUP = 38;
export const SECOND_MINI_MATCH_GROUP = 39;
export const THIRD_MINI_MATCH_GROUP = 40;
export const FOURTH_MINI_MATCH_GROUP = 41;
export const FIFTH_MINI_MATCH_GROUP = 42;
export const SIXTH_MINI_MATCH_GROUP = 43;
export const CORNER_GROUP = 44;
export const FIRST_PERIOD_CORNER_GROUP = 45;
export const YELLOW_CARD_GROUP = 46;
export const FIRST_PERIOD_YELLOW_CARD_GROUP = 47;
export const BASKETBALL_MATCH_TWO_POINTS_GROUP = 48;
export const BASKETBALL_MATCH_THREE_POINTS_GROUP = 49;
export const ICE_HOCKEY_FIRST_MINI_MATCH_GROUP = 50;
export const ICE_HOCKEY_SECOND_MINI_MATCH_GROUP = 51;
export const ICE_HOCKEY_THIRD_MINI_MATCH_GROUP = 52;
export const ICE_HOCKEY_FOURTH_MINI_MATCH_GROUP = 53;
export const ICE_HOCKEY_FIFTH_MINI_MATCH_GROUP = 54;
export const ICE_HOCKEY_SIXTH_MINI_MATCH_GROUP = 55;
export const FIRST_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = 56;
export const FIRST_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = 57;
export const SECOND_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = 58;
export const SECOND_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = 59;
export const THIRD_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = 60;
export const THIRD_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = 61;
export const FOURTH_PERIOD_TEN_POINTS_MINI_MATCH_GROUP = 62;
export const FOURTH_PERIOD_FIFTEEN_POINTS_MINI_MATCH_GROUP = 63;
export const OVERTIME_GROUP = 64;
export const FIRST_OVERTIME_GROUP = 65;
export const SECOND_OVERTIME_GROUP = 66;
export const PENALTIES_GROUP = 67;
export const FIRST_HALF_GROUP = 68;
export const SECOND_HALF_GROUP = 69;


// WEBPACK FOOTER //
// ./js/constants/GroupType.js